// extracted by mini-css-extract-plugin
export default {"footerx":"Footer_footerx__bb2iY","container":"Footer_container__Yhzqi","socialMediaContainer":"Footer_socialMediaContainer__-8+lV"};